/* Inyecta la tira de "envío gratis" al pie del pop-up de compra rápida.
 *
 * El contenido del pop-up lo trae el tema por fetch cada vez que se abre, así
 * que no alcanza con ponerla una vez: hay que observar el contenedor y volver
 * a colgarla cuando se re-renderiza. La tira sale del mismo <template> que
 * emite el layout, de modo que es la misma pieza que la de las tarjetas.
 */
(function () {
  var TPL = 'sd-qa-ship';
  var MODAL = '#hdt-quick-add-modal';

  function pegarTira(modal) {
    var tpl = document.getElementById(TPL);
    if (!tpl) return;

    var inner = modal.querySelector('.hdt-dialog-modal__inner');
    if (!inner) return;

    // Va dentro del grupo de botones, que es el flex que ordena COMPRAR AHORA
    // y ANADIR AL CARRITO; asi la tira queda tercera sin trucos de posicion.
    var destino = inner.querySelector('.hdt-product-form__buttons')
      || inner.querySelector('.hdt-product__buy-button')
      || inner.firstElementChild;
    if (!destino) return;
    if (destino.querySelector('.sd-qa-ship')) return;

    var tira = tpl.content.firstElementChild;
    if (!tira) return;
    destino.appendChild(tira.cloneNode(true));
  }

  // El pop-up no scrollea nunca: si el contenido no entra en el alto de la
  // pantalla (iPhone SE y similares), se achica todo parejo con zoom sobre los
  // hijos del contenedor (--sd-qa-zoom en quickadd-salty.css; el contenedor no,
  // porque su alto máximo se achicaría junto con el contenido). Se mide a
  // tamaño completo y se aplica en el mismo cuadro, así no titila.
  var ZOOM_MIN = 0.6;
  function ajustar(modal) {
    var inner = modal.querySelector('.hdt-dialog-modal__inner');
    if (!inner || !modal.open) return;
    inner.style.setProperty('--sd-qa-zoom', '1');
    var cs = getComputedStyle(inner);
    var pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var disponible = inner.clientHeight - pad;   // ya limitado por el max-height del CSS
    var natural = inner.scrollHeight - pad;
    var z = 1;
    if (natural > disponible + 1) {
      z = Math.max(ZOOM_MIN, Math.floor(disponible / natural * 1000) / 1000);
    }
    inner.style.setProperty('--sd-qa-zoom', String(z));
  }

  function enganchar() {
    var modal = document.querySelector(MODAL);
    if (!modal) return false;

    var inner = modal.querySelector('.hdt-dialog-modal__inner');
    if (!inner) return false;

    var cuadro = 0;
    function programar() {
      cancelAnimationFrame(cuadro);
      cuadro = requestAnimationFrame(function () { ajustar(modal); });
    }

    pegarTira(modal);
    new MutationObserver(function () { pegarTira(modal); programar(); })
      .observe(inner, { childList: true, subtree: true });
    // Al abrirse (atributo open) y al cambiar el tamaño de la pantalla
    new MutationObserver(programar).observe(modal, { attributes: true, attributeFilter: ['open'] });
    window.addEventListener('resize', programar);
    inner.addEventListener('load', programar, true);   // miniatura y GIF de la tira
    return true;
  }

  function iniciar() {
    if (enganchar()) return;
    // El modal es perezoso: puede no existir todavia al cargar la pagina.
    var obs = new MutationObserver(function () {
      if (enganchar()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
